import debounce from '../commons/helpers/debounce';

const { $ } = window;

const YurPlanWidgets = {
    EVENT_TYPES: {
        AUTO_HEIGHT: 'autoHeight',
        CHANGE_STEP: 'changeStep',
        SCROLL_IFRAME: 'scrollIframe',
    },
    STEPS: {
        TICKETS: 'tickets',
        FORM: 'form',
        PRODUCTS: 'products',
        CONFIRMATION: 'confirmation',
        SUMMARY: 'summary',
    },
};

function widgetOrgaSendInfoToPage(type) {
    const el = $('#yurplan-widget-body');
    const height = el.outerHeight(true);
    const { widgetConfiguration } = window;

    widgetConfiguration.height = height;

    try {
        window.parent.postMessage({
            id: null,
            orgaId: el.data('id'),
            data: widgetConfiguration,
            type,
        }, '*');
    } catch (e) {
        /* eslint-disable-next-line no-console */
        console.log('Failed postMessage to window.parent', e);
    }
}

$(() => {
    const widgetBody = document.getElementById('yurplan-widget-body');
    if (widgetBody) {
        // Options for the observer (which mutations to observe)
        const config = {
            attributes: true,
            childList: true,
            subtree: true,
        };
        const triggerAutoHeightCallback = debounce(
            widgetOrgaSendInfoToPage.bind(
                null,
                YurPlanWidgets.EVENT_TYPES.AUTO_HEIGHT,
            ),
            300,
        );
        // Create an observer instance linked to the callback function
        // const domSubtreeObserver = new MutationObserver(triggerAutoHeightCallback);

        // Create an observer instance linked to the callback function
        const domSubtreeObserver = new MutationObserver((mutationsList) => {
            const skipEvent = mutationsList.every(mutation => mutation.target.className.indexOf('ticketing_timer_update') > -1);
            if (skipEvent) return;
            triggerAutoHeightCallback();
        });

        // Start observing the target node for configured mutations
        domSubtreeObserver.observe(widgetBody, config);
        // Also watch resize event
        $(window).on('resize load', triggerAutoHeightCallback);
    }

    $('a.toggleDesc').click(function toggleDescriptionOnClick(e) {
        e.preventDefault();
        if ($(this).closest('.js-parent').find('.description_all').hasClass('visible')) {
            $(this).html($(this).data('open'));
            $(this).closest('.js-parent').find('.description_all').hide();
            $(this).closest('.js-parent').find('.description_all').removeClass('visible');
        } else {
            $(this).html($(this).data('close'));
            $(this).closest('.js-parent').find('.description_all').show();
            $(this).closest('.js-parent').find('.description_all').addClass('visible');
        }
    });

    window.addEventListener('message', (event) => {
        // Only relay specific message types from the event iframe to the external page.
        // autoHeight is NOT relayed because the orga's own MutationObserver already
        // sends the correct total height (event content + orga header).
        const relayTypes = ['scrollIframe', 'changeStep', 'onload', 'tracking'];
        if (!event.data?.type || !relayTypes.includes(event.data.type)) return;

        try {
            window.parent.postMessage({
                ...event.data,
                orgaId: $('#yurplan-widget-body').data('id'),
            }, '*');
        } catch (e) {
            /* eslint-disable-next-line no-console */
            console.log('Failed postMessage to window.parent', e);
        }
    }, false);
});
